var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7857 6.14286H13.5714V9.71429H19.8393L18.4375 6.56696C18.3214 6.30804 18.067 6.14286 17.7857 6.14286ZM20.3571 11.8571H4.64286V21.1429C4.64286 21.5357 4.96429 21.8571 5.35714 21.8571H19.6429C20.0357 21.8571 20.3571 21.5357 20.3571 21.1429V11.8571ZM5.16071 9.71429H11.4286V6.14286H7.21429C6.93304 6.14286 6.67411 6.30804 6.5625 6.56696L5.16071 9.71429ZM17.7857 4C18.9152 4 19.9375 4.66518 20.3973 5.69643L22.2545 9.875C22.4152 10.2411 22.5 10.6339 22.5 11.0357V21.1429C22.5 22.7188 21.2188 24 19.6429 24H5.35714C3.78125 24 2.5 22.7188 2.5 21.1429V11.0357C2.5 10.6339 2.58482 10.2411 2.74554 9.875L4.60268 5.69643C5.0625 4.66518 6.08482 4 7.21429 4H17.7857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.94ae109c0fd14abc614d8e4cced43cdc.svg";
export { ForwardRef as ReactComponent };